import TagBox from "devextreme-react/tag-box";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { financeHelperApi } from "../../../../api/finance/financeHelperApi";
import { hocSinhApi } from "../../../../api/hocsinh_api";
import { DefaultButton, PrimaryButton } from '../../../../components/editor/button';
import { showNotify } from '../../../../helpers/toast';
import styles from '../TinhBaoPhi.module.css'

const SendEmailModal = ({ ts_hocsinh, sf_tinhbaophi_editing, onSelected, onCancel }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { dm_coso_id } = useSelector((x) => x.coSo);
    const [suggest_emails, set_suggest_emails] = useState([]);
    const [email_to_send_when_finish, set_email_to_send_when_finish] = useState([]);
    useEffect(() => {
        handleReloadEmail();
    }, [ts_hocsinh]);
    const handleReloadEmail = async () => {
        const res = await hocSinhApi.SelectSuggestEmail(ts_hocsinh.id);
        if (res.is_success) {
            set_suggest_emails(res.data);
        }
    }

    const hanldeSubmit = async () => {
        setIsLoading(true)
        const res = await financeHelperApi.sf_tinhbaophi_send_baophi({
            sf_tinhbaophi_id: sf_tinhbaophi_editing.id,
            dm_coso_id: dm_coso_id,
            emails: email_to_send_when_finish
        });

        if (res.is_success) {
            showNotify({ message: "Đã gửi email báo phí", type: "success" });
            onCancel();
        } else {
            showNotify({ message: "Không gửi được báo phí", type: "warning" });
        }
        setIsLoading(false)
        onSelected()
    }
    
    return (
        <Modal
            open={true}
            dimmer={'blurring'}
            closeOnEscape={false}
            closeOnDimmerClick={false}
            size="small"
            className={styles.modal_center}

        >
            <Modal.Header>
                <div className="label">{`${ts_hocsinh.ma_hs} - ${ts_hocsinh.ho_ten} - Gửi email báo phí`}</div>
            </Modal.Header>
            <Modal.Content>
                <div className="pop-up-form">
                    <div className="col-md-12 padding-top-1rem">
                        <h4>Chọn Email từ danh sách bên dưới hoặc điền email mới để gửi</h4>
                        <div className="margin-bottom-5">Gửi tới Email:</div>
                        <br />
                        <TagBox
                            items={suggest_emails}
                            showSelectionControls={true}
                            searchEnabled
                            displayExpr={'email'}
                            valueExpr={'email'}
                            value={email_to_send_when_finish}
                            multiline={true}
                            stylingMode="outlined"
                            width={'100%'}
                            showClearButton={true}
                            height={'auto'}
                            applyValueMode="useButtons"
                            acceptCustomValue={true}
                            onValueChanged={e => {
                                set_email_to_send_when_finish(e.value || []);
                            }}
                            onCustomItemCreating={e => {
                                const newItem = e.text.trim();
                                const lowerCasedNewValue = newItem.toLowerCase();
                                if (newItem && !suggest_emails.some(item => item.email.toLowerCase() === lowerCasedNewValue)) {
                                    const newEmail = { email: newItem };
                                    set_suggest_emails([...suggest_emails, newEmail]);
                                    e.customItem = new Promise(resolve => {
                                        resolve(newEmail);
                                    });
                                    set_email_to_send_when_finish([...email_to_send_when_finish, newEmail.email]);
                                }
                            }}
                        />
                        <br />
                    </div>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <DefaultButton type="normal" text="Đóng" onClick={() => { onCancel() }} /> {' '}
                <PrimaryButton type="success" text="Gửi"
                    isLoading={isLoading}
                    isDisabled={set_email_to_send_when_finish.length === 0}
                    onClick={hanldeSubmit} />
            </Modal.Actions>
        </Modal>
    );
}
export default SendEmailModal;